{
  "version": 1,
  "asset_id": "566c58e9-a981-4c24-bf0d-3353b3475539",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/566c58e9-a981-4c24-bf0d-3353b3475539/nieuwbouw-640.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/566c58e9-a981-4c24-bf0d-3353b3475539/nieuwbouw-640.avif",
  "original_filename": "nieuwbouw-640.avif",
  "size": 19697,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:30Z"
}
